import { motion } from "framer-motion";
import { GALLERY } from "../../data/content";

export const Gallery = () => {
  return (
    <section id="galeria" data-testid="gallery-section" className="bg-[#0A0A0A] py-24 border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-12">
          <span className="font-body text-sm tracking-[0.25em] uppercase text-[#FF1616]">Galería</span>
          <h2 className="font-heading font-black uppercase text-white text-3xl sm:text-4xl tracking-tight mt-3">
            Nuestro trabajo en campo
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className={`group relative overflow-hidden border border-[#262626] ${i === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.url}
                alt={g.alt}
                className={`w-full object-cover group-hover:scale-110 transition-transform duration-700 ${i === 0 ? "h-64 md:h-full" : "h-44 md:h-56"}`}
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all">
                <span className="font-body text-xs uppercase tracking-wider text-white">{g.alt}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
